// extracted by mini-css-extract-plugin
export default {"container":"productadd_container__V2U3n","header":"productadd_header__8a8SF"};